import React from "react";
import SvgIcon from "../../../../parts/SvgIcon";
import { COACH_ACTIVITY_METRICS } from "../coachingHelpers";
import { hasSummaryColumn } from "../monthSummary";

const TOTAL_LABEL_METRICS = new Set([
  "videos",
  "bodyMeasurements",
  "bodyPhotos",
  "mealPhotos",
  "coach-notes",
  ...COACH_ACTIVITY_METRICS,
]);

// "completed" -> Done, "total" -> Total, "cycleDay" -> Cycle day, else Avg.
const getSummaryKind = (metric) => {
  if (!metric || metric === "workouts" || metric === "check-in")
    return "completed";
  if (metric === "menstrualCycle") return "cycleDay";
  return TOTAL_LABEL_METRICS.has(metric) ? "total" : "average";
};

/**
 * Day columns match athletes[0][dataKey] (length = days in month).
 */
export function DashboardTableHeader({
  metric,
  dataKey,
  athletes,
  today,
  isCurrentMonth,
  onSortName,
  onSortWorkouts,
  onSortLastLogged,
  onSortSummary,
  showWorkoutsColumn,
  t,
}) {
  const dayColumns = athletes[0]?.[dataKey] ?? [];
  const showSummary = hasSummaryColumn(metric);
  const summaryKind = getSummaryKind(metric);

  return (
    // biome-ignore lint/a11y/useValidAriaRole: report-header used for table structure
    <thead role="report-header">
      <tr>
        <th onClick={() => onSortName()}>
          {t("coachingDashboard.name")}
          <SvgIcon src="/img/svg/up_down_arrows.svg" />
        </th>
        {showWorkoutsColumn && (
          <th onClick={() => onSortWorkouts()}>
            <SvgIcon src="/img/svg/up_down_arrows.svg" />
          </th>
        )}
        <th className="last-logged-header" onClick={() => onSortLastLogged()}>
          <div>
            {COACH_ACTIVITY_METRICS.has(metric) ||
            metric === "coach-notes" ||
            !metric ||
            metric === "workouts"
              ? t("coachingDashboard.daysSince")
              : t("coachingDashboard.lastLogged")}
            <SvgIcon src="/img/svg/up_down_arrows.svg" />
          </div>
        </th>
        {dayColumns.map((_, idx) => (
          <th
            className={`day ${
              metric === "bodyWeight" ? "bodyWeight" : ""
            } ${idx + 1 === today && isCurrentMonth ? "today" : ""}`}
            key={`day-${1 + idx}`}
            {...(idx + 1 === today && isCurrentMonth
              ? { "data-today-label": t("coachingDashboard.todayColumnBadge") }
              : {})}
          >
            <div>{idx + 1}</div>
          </th>
        ))}
        {showSummary && (
          <th className="summary-header" onClick={() => onSortSummary()}>
            <div>
              <SvgIcon src="/img/svg/up_down_arrows.svg" />
              {t(`coachingDashboard.summary.${summaryKind}`)}
              {summaryKind !== "cycleDay" && (
                <span className="summary-window">
                  {t("coachingDashboard.summary.window")}
                </span>
              )}
              <span
                className="summary-info"
                data-tooltip-id="summary-header-info"
                data-tooltip-content={t(
                  `coachingDashboard.summary.${summaryKind}Tooltip`
                )}
              >
                <SvgIcon
                  src="/img/svg/info-circle.svg"
                  useCurrentColor
                  classNames="w-5 h-5"
                />
              </span>
            </div>
          </th>
        )}
      </tr>
    </thead>
  );
}
